<template>
  <div class="wrap product m-a p-r" id="wrap">
    <!--include virtual="/inc/head"-->
    <!--#include virtual="/inc/common/header0526"-->
    <!-- header:end -->
    <section class="banner p-r">
      <h1 class="banner-title p-a c-c ff-as">{{ $t('common.product.productTitle') }}</h1>
    </section>
    <!-- banner:end -->
    <section class="content-wrap">
      <div class="content-in m-a">
        <div class="left-menu f-l">
          <div class="product-bar d-n">All Products</div>
          <ul id="left-menu">
            <li>
              <a class="curr">{{ $t('common.product.leftMenu1') }}</a>
            </li>
            <li>
              <a>{{ $t('common.product.leftMenu2') }}</a>
            </li>
            <li>
              <a>{{ $t('common.product.leftMenu3') }}</a>
            </li>
            <li>
              <a>{{ $t('common.product.leftMenu4') }}</a>
            </li>
            <li>
              <a>{{ $t('common.product.leftMenu5') }}</a>
            </li>
            <!-- <li><a>General</a></li> -->
          </ul>
        </div>
        <div class="right-content f-r">
          <ul>
            <li>
              <i
                ><img
                  src="@/assets/images/nav0526/nav_1904.png"
                  :title="$t('common.product.kitTitle')"
                  :alt="$t('common.product.kitTitle')"
              /></i>
              <h2>{{ $t('common.product.kitTitle') }}</h2>
              <p>{{ $t('common.product.kitContent') }}</p>
              <a href="/product/autosteeringkit" :title="$t('common.product.moreBtn')" class="more-icon d-b p-a">{{
                $t('common.product.moreBtn')
              }}</a>
            </li>
            <li>
              <i
                ><img
                  src="@/assets/images/nav0526/nav_pdj.png"
                  :title="$t('common.product.systemTitle')"
                  :alt="$t('common.product.systemTitle')"
              /></i>
              <h2>{{ $t('common.product.systemTitle') }}</h2>
              <p>{{ $t('common.product.systemContent') }}</p>
              <a
                href="/product/al01-3d-land-leveling-system"
                :title="$t('common.product.moreBtn')"
                class="more-icon d-b p-a"
                >{{ $t('common.product.moreBtn') }}</a
              >
            </li>
          </ul>

          <ul class="d-n">
            <li>
              <i
                ><img
                  src="@/assets/images/nav0526/nav_wjj.png"
                  :title="$t('common.product.guidanceTitle')"
                  :alt="$t('common.product.guidanceTitle')"
              /></i>
              <h2>{{ $t('common.product.guidanceTitle') }}</h2>
              <p>{{ $t('common.product.guidanceContent') }}</p>
              <a href="/product/excavatorguidance" :title="$t('common.product.moreBtn')" class="more-icon d-b p-a">{{
                $t('common.product.moreBtn')
              }}</a>
            </li>
            <li>
              <i
                ><img
                  src="@/assets/images/nav0526/nav_dzj.png"
                  :title="$t('common.product.pileTitle')"
                  :alt="$t('common.product.pileTitle')"
              /></i>
              <h2>{{ $t('common.product.pileTitle') }}</h2>
              <p>{{ $t('common.product.pileContent') }}</p>
              <a href="/product/piledriver" :title="$t('common.product.moreBtn')" class="more-icon d-b p-a">{{
                $t('common.product.moreBtn')
              }}</a>
            </li>
          </ul>
          <ul class="d-n">
            <li>
              <i
                ><img
                  src="@/assets/images/nav0526/nav_3dsmy.png"
                  :title="$t('common.product.lawnmowerTitle')"
                  :alt="$t('common.product.lawnmowerTitle')"
              /></i>
              <h2>{{ $t('common.product.scannerTitle') }}</h2>
              <p>{{ $t('common.product.scannerContent') }}</p>
              <a
                href="/product/trion-s1-3d-lidar-scanner"
                :title="$t('common.product.moreBtn')"
                class="more-icon d-b p-a"
                >{{ $t('common.product.moreBtn') }}</a
              >
            </li>
          </ul>

          <ul class="d-n">
            <li>
              <i
                ><img
                  src="@/assets/images/nav0526/nav_gcj.png"
                  :title="$t('common.product.lawnmowerTitle')"
                  :alt="$t('common.product.lawnmowerTitle')"
              /></i>
              <h2>{{ $t('common.product.vidarTitle') }}</h2>
              <p>{{ $t('common.product.vidarContent') }}</p>
              <a href="/product/lawnmower" :title="$t('common.product.moreBtn')" class="more-icon d-b p-a">{{
                $t('common.product.moreBtn')
              }}</a>
            </li>
            <li>
              <i
                ><img
                  src="@/assets/images/nav0526/nav_cnb.png"
                  :title="$t('common.product.powersecTitle')"
                  :alt="$t('common.product.powersecTitle')"
              /></i>
              <h2>{{ $t('common.product.powersecTitle') }}</h2>
              <p>{{ $t('common.product.powersecContent') }}</p>
              <a href="/product/powersec" :title="$t('common.product.moreBtn')" class="more-icon d-b p-a">{{
                $t('common.product.moreBtn')
              }}</a>
            </li>
          </ul>
          <ul class="d-n">
            <li>
              <i
                ><img
                  src="@/assets/images/nav0526/nav_jz.png"
                  :title="$t('common.product.rtkTitle')"
                  :alt="$t('common.product.rtkTitle')"
              /></i>
              <h2>{{ $t('common.product.rtkTitle') }}</h2>
              <p>{{ $t('common.product.rtkContent') }}</p>
              <a href="/product/basestation" :title="$t('common.product.moreBtn')" class="more-icon d-b p-a">{{
                $t('common.product.moreBtn')
              }}</a>
            </li>
            <li>
              <i
                ><img
                  src="@/assets/images/nav0526/nav_wfsct.png"
                  :title="$t('common.product.cameraTitle')"
                  :alt="$t('common.product.cameraTitle')"
              /></i>
              <h2>{{ $t('common.product.cameraTitle') }}</h2>
              <p>{{ $t('common.product.cameraContent') }}</p>
              <a href="/product/wificamera" :title="$t('common.product.moreBtn')" class="more-icon d-b p-a">{{
                $t('common.product.moreBtn')
              }}</a>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <!-- footer:start -->
    <!--include virtual="/inc/foot"-->
    <!--#include virtual="/inc/common/footer0526"-->
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    created() {},
    mounted() {
      this.changeTabLst()
    },
    methods: {
      changeTabLst() {
        const tabList = document.querySelectorAll('.left-menu a')
        const contentList = document.querySelectorAll('.right-content ul')
        for (let i = 0; i < tabList.length; i++) {
          const currentLi = tabList[i]
          currentLi.id = i
          currentLi.addEventListener('click', function () {
            for (let j = 0; j < tabList.length; j++) {
              tabList[j].className = ''
              contentList[j].style.display = 'none'
            }
            this.className = 'curr'
            contentList[this.id].style.display = 'block'
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .f-l {
    float: left;
  }
  .product .banner {
    height: 3.6rem;
    margin-top: 3.958vw;
    background: url('@/assets/images/product/product_banner.jpg') no-repeat center;
    background-size: cover;
  }
  .product .banner .banner-title {
    font-size: 0.48rem;
    font-weight: 700;
    color: #fff;
  }
  .content-wrap {
    background-color: #f7f8f9;
    padding: 30px 0;
  }
  .content-in {
    width: 1000px;
  }
  .content-in:after {
    content: '';
    display: block;
    height: 0;
    font-size: 0;
    clear: both;
  }
  .left-menu {
    width: 194px;
    background-color: #fff;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    z-index: 5;
  }
  .left-menu a {
    display: block;
    cursor: pointer;
    font-size: 16px;
    position: relative;
    color: #666;
  }
  .left-menu .curr,
  .left-menu a:hover {
    color: #333;
    font-weight: 600;
  }
  .left-menu .curr:after {
    transform: rotate(90deg);
    content: '';
    display: block;
    position: absolute;
    right: 0;
    top: 0;
    width: 16px;
    height: 20px;
    background: url("data:image/svg+xml,%3Csvg width='22' height='14' viewBox='0 0 22 14' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.065 1l10.94 11.243a2.056 2.056 0 0 1-2.948 0L9.592 2.517 11.065 1zm1.481 1.525l-9.59 9.86a2.058 2.058 0 0 1-2.952-.001L11.075 1.013l1.473 1.514-.002-.002z' fill='%23333' fill-rule='nonzero'/%3E%3C/svg%3E")
      no-repeat center;
    background-size: 100% auto;
  }
  .left-menu ul {
    padding: 15px 6px 15px 10px;
  }
  .left-menu ul li {
    padding: 13px 0;
  }
  .product .right-content {
    width: 781px;
  }
  .product .right-content ul {
    margin-left: -25px;
    overflow: hidden;
  }
  .product .right-content li {
    float: left;
    position: relative;
    margin-left: 25px;
    margin-bottom: 25px;
    width: 378px;
    height: 464px;
    background-color: #fff;
  }
  .right-content li i {
    display: block;
    margin: 0 auto;
    text-align: center;
  }
  .right-content li img {
    height: 200px;
  }
  .right-content li h2 {
    padding: 8px 23px 12px;
    color: #333;
    font-size: 20px;
    font-weight: 600;
  }
  .right-content li p {
    padding: 0 23px;
    line-height: 24px;
    font-size: 16px;
    color: #999;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .right-content li .more-icon {
    color: #333;
    font-size: 16px;
    left: 23px;
    bottom: 26px;
    font-weight: 600;
  }
  .right-content li .more-icon:after {
    content: '';
    display: inline-block;
    margin-left: 15px;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    background: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h24v24H0z'/%3E%3Cpath d='M10.015 3.22A9 9 0 1 0 20.76 14.075M21 3l-9 9' stroke='%23333' stroke-width='1.2' stroke-linecap='round'/%3E%3Cpath stroke='%23333' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round' d='M15 3h6v6'/%3E%3C/g%3E%3C/svg%3E")
      no-repeat center;
    background-size: cover;
  }
  .right-content li .more-icon:hover {
    color: #000;
  }
  /* solution */
  /* reset */
  a {
    text-decoration: none;
    color: #fff;
  }
  a:active {
    border: none;
    background-color: transparent;
  }
  a:hover {
    color: #fff;
  }
  .f-l {
    float: left;
  }
  .f-r {
    float: right;
  }
  .d-n {
    display: none;
  }
</style>
